import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AdminHttpService {

  private base_url = `/iam/users`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAll(params?: any): Observable<any[]> {
    return this.http
      .get<any[]>(this.base_url, {params})
      .pipe(map((admins) => admins));
  }

  getByIds(ids: string[]): Observable<any[]> {
    return this.http
      .get<any[]>(this.base_url, {params: {ids}})
      .pipe(map((admins) => admins));
  }

  searchByTerm(searchTerm: string): Observable<any[]> {
    return this.http
      .get<any[]>(this.base_url, {params: {searchTerm}})
      .pipe(map((admins) => admins));
  }
}
